import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "../components/CircularProgress";
import Network, { BattleURL, IsBeta } from "../utils/Network";
import { useParams, useSearchParams } from "react-router-dom";
import { setPlayable } from "../redux/music/action";
import { useAppTranslation } from "../i18n/useAppTranslation";

type Props = {};

const Adventure3DReplay = (props: Props) => {
  const dispatch = useDispatch();
  const axios = new Network();
  const { t } = useAppTranslation("adventure");
  const id = useParams().id;
  const [isLoading, setIsLoading] = useState(false);
  const [iframeURL, setIframeURL] = useState<string>("");
  const [error, setError] = useState({
    hasError: false,
    message: "",
  });
  const getAdventure3DReplay = async (id: string | undefined) => {
    if (!id) {
      return setError({
        hasError: true,
        message: t("adventure:replay.errors.noAdventureId"),
      });
    }
    setIsLoading(true);
    const response = await axios.CallApi<any>({
      url: `/adventure/${id}`,
      method: "GET",
    });
    setIsLoading(false);
    if (response.ok) {
      if (response.data?.replayUrl) {
        setIframeURL(response.data.replayUrl);
      } else {
        setError({
          hasError: true,
          message: t("adventure:replay.errors.noReplay"),
        });
      }
    } else {
      setError({
        hasError: true,
        message: t("adventure:replay.errors.notFound"),
      });
    }
  };
  useEffect(() => {
    getAdventure3DReplay(id);
  }, [id, t]);
  useEffect(() => {
    dispatch(setPlayable(false));
  }, []);

  return (
    <>
      {isLoading && (
        <div
          style={{ backgroundColor: "rgba(0,0,0,.5)" }}
          className="d-flex  justify-content-center align-items-center w-100 h-100 position-absolute top-0 left-0"
        >
          <CircularProgress />
        </div>
      )}
      {error.hasError && (
        <div className="d-flex justify-content-center align-items-center w-100 h-100 position-absolute top-0 left-0">
          <p>{error.message}</p>
        </div>
      )}
      {iframeURL && (
        <iframe
          src={iframeURL}
          width="100%"
          height="100%"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 10,
          }}
          frameBorder="0"
          allowFullScreen
        ></iframe>
      )}
    </>
  );
};

export default Adventure3DReplay;
